export default from './post-stats';



// WEBPACK FOOTER //
// ./app/components/post-stats/index.js